export default IconStairsDown => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-stairs-down" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M22 21h-5v-5h-5v-5h-5v-5h-5" />
  <path d="M18 3v7" />
  <path d="M15 7l3 3l3 -3" />
</svg>`;